import { SignatureHeadline } from "@dialogueconsulting/sked-ui";

import { CountdownCircle } from "./count-down-circle";
import { useState } from "react";
import { PostFormState } from "../../../../shared/types/post";
import { PostStatesType } from "../../../../constants/PostsView";
import { useDispatch } from "react-redux";
import { closePostFormInBulkCreate } from "../../bulk-create/bulk-create-post.actions";
import { Button } from "../../../../components/ui/button";

export const PostSaveSuccess = ({
  onRequestOpenPosts,
  postState = "DRAFT",
  onRequestCloseTab,
}: {
  onRequestOpenPosts?: () => void;
  postState?: PostStatesType;
  onRequestCloseTab?: () => void;
}) => {
  const [isPauseClosing, setIsPauseClosing] = useState(false);
  const [isPauseCountdown, setIsPauseCountdown] = useState(false);
  function resolveText() {
    switch (postState) {
      case "DRAFT": {
        return "Your draft has been successfully saved.";
      }
      case "SCHEDULED": {
        return "Your post has been successfully scheduled.";
      }
      case "QUEUED": {
        return "Your post has been successfully scheduled.";
      }
      default: {
        return "Your post has been successfully saved.";
      }
    }
  }
  /**
   * The word set in Tiempos italic. Kept in lockstep with resolveText(): it
   * must appear VERBATIM in that string or the headline renders plain, so the
   * two switches change together.
   */
  function resolveHighlight() {
    switch (postState) {
      case "DRAFT": {
        return "saved";
      }
      case "SCHEDULED":
      case "QUEUED": {
        return "scheduled";
      }
      default: {
        return "saved";
      }
    }
  }
  function resolveOpenSavedPostLabel() {
    switch (postState) {
      case "DRAFT": {
        return "See saved draft(s)";
      }
      case "SCHEDULED": {
        return "See scheduled post(s)";
      }
      case "QUEUED": {
        return "See queued post(s)";
      }
      default: {
        return "See in saved posts";
      }
    }
  }
  return (
    <div className="flex h-full items-center p-[24px]">
      <div className="flex flex-1 p-[40px]">
        <div className="flex flex-col flex-1 gap-[24px]">
          <i className="fa fa-calendar-check text-[64px] text-green-500" />
          {/* SKE-4312 — a genuine see-occasionally moment: the confirmation
              after a post is scheduled. `animate` is safe here (you land on
              this once per publish, not on every screen paint) and the shared
              component keeps it reduced-motion-safe. */}
          <SignatureHeadline
            as="h2"
            size="none"
            tone="inherit"
            animate
            className="text-[48px] leading-[60px] text-blue-700"
            text={resolveText()}
            highlight={resolveHighlight()}
          />
          <div className="flex gap-[16px]">
            <Button
              onMouseEnter={() => setIsPauseCountdown(true)}
              onMouseLeave={() => setIsPauseCountdown(false)}
              size="md"
              onClick={() => onRequestCloseTab?.()}
              className="w-[196px]"
            >
              <div className="flex items-center text-[12px]">
                <span>Close this tab</span>
                {!isPauseClosing && (
                  <>
                    <span className="pl-[12px] mr-[-8px] relative">
                      <CountdownCircle
                        radius={10}
                        seconds={1}
                        strokeWidth={1}
                        textClassName="font-normal font-white"
                        strokeForeground="white"
                        strokeBackground="transparent"
                        onComplete={() => onRequestCloseTab?.()}
                        isPaused={isPauseCountdown}
                      />
                    </span>
                  </>
                )}
              </div>
            </Button>

            <Button
              size="md"
              onClick={() => setIsPauseClosing(true)}
              className="w-[10px] pl-[20px] pr-[20px]"
            >
              <i className="fa fa-pause" />
            </Button>
            <Button
              size="md"
              onClick={() => onRequestOpenPosts?.()}
              className="w-[240px]"
              variant="blue-secondary"
            >
              {resolveOpenSavedPostLabel()}
            </Button>
          </div>
        </div>
        <img
          className="object-contain max-w-full min-w-0"
          src="/assets/img/reading.png"
        />
      </div>
    </div>
  );
};

const openPostDataKey = "openPostData";
export const setRequestedPostData = (
  data: PostFormState["formSaveData"] | undefined
) => {
  if (!data) {
    localStorage.removeItem(openPostDataKey);
    return;
  }
  localStorage.setItem(openPostDataKey, JSON.stringify(data));
};
export const pullRequestedPostData = ():
  PostFormState["formSaveData"] | undefined => {
  const data = localStorage.getItem(openPostDataKey);
  try {
    setRequestedPostData(undefined);
    return data ? JSON.parse(data) : undefined;
  } catch (error) {
    console.error("Error parsing openPostData:", error);
    return undefined;
  }
};

export const StatePostSaveSuccess = ({ form }: { form: PostFormState }) => {
  const dispatch = useDispatch();
  return (
    <PostSaveSuccess
      postState={form.postState}
      onRequestOpenPosts={() => {
        setRequestedPostData(form.formSaveData);
        window.open(
          `${window.location.origin}?hrm=true&open-posts=true`,
          "_blank"
        );
      }}
      onRequestCloseTab={() => {
        dispatch(
          closePostFormInBulkCreate({
            postId: form.post._id,
            actionOnCloseSelected: "select-next",
          })
        );
      }}
    />
  );
};
